import React from 'react';
import styled from '@benzinga/themetron';
import { CalendarTab } from './CalendarsWidget/CalendarsDefs/Calendars';

const showDataAffixForCalendars = ['Earnings', 'Options'];

export const NoRowsOverlay: React.FC<{ calendarName: CalendarTab; initialTickers?: string[]; text?: string }> = ({
  calendarName,
  initialTickers,
  text,
}) => {
  const NoFoundText = `Sorry, no ${calendarName} ${
    showDataAffixForCalendars.includes(calendarName) ? 'data' : ''
  } found`;

  if (text) {
    return <NoEntriesFound className="no-entries-found-text">{text}</NoEntriesFound>;
  }

  if (initialTickers && initialTickers.length > 0) {
    const tickers = (Array.isArray(initialTickers) ? initialTickers.join(', ') : initialTickers).toUpperCase();

    return (
      <NoEntriesFound>
        {NoFoundText} for {tickers}
      </NoEntriesFound>
    );
  }

  return <NoEntriesFound className="no-entries-found-text">{NoFoundText}</NoEntriesFound>;
};

export default NoRowsOverlay;

const NoEntriesFound = styled.div`
  font-weight: bold;
  font-size: 12px;
`;
